import { useEffect, useState } from 'react';
import mascotImg from '../assets/Asset_233x.png';
import '../styles/mascot.css';

const Mascot = ({ size = 260 }) => {
  const [scrollY, setScrollY] = useState(0);
  const [pageH, setPageH] = useState(1);
  const [winH, setWinH] = useState(window.innerHeight);

  useEffect(() => {
    const update = () => {
      setScrollY(window.scrollY);
      setPageH(document.body.scrollHeight - window.innerHeight || 1);
      setWinH(window.innerHeight);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  // появляется после прокрутки 40% первого экрана
  const triggerY = winH * 0.4;
  const appeared = scrollY > triggerY;

  // top: от 20vh до 70vh пропорционально прокрутке страницы
  const progress = Math.min(scrollY / pageH, 1);
  const top = winH * (0.2 + progress * 0.5);

  // горизонтальное смещение: скрыт на 62%, виден на 38%
  const slideX = appeared ? '62%' : '105%';

  return (
    <div
      aria-hidden="true"
      className="mascot-fixed"
      style={{ top, width: size, height: size }}
    >
      <img
        src={mascotImg}
        alt=""
        style={{ transform: `translateX(${slideX}) rotate(40deg)` }}
        className="mascot-fixed__img"
      />
    </div>
  );
};

export default Mascot;
